import { c as _c } from "react/compiler-runtime";
import { TextInput } from '@repo/design-system/components/ui/text-input';
import { css } from '@repo/panda/css';
import type React from 'react';
export interface MapSearchProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  onFocus?: () => void;
  onBlur?: () => void;
  autoFocus?: boolean;
  inputRef?: React.Ref<HTMLInputElement>;
}
export const MapSearch: React.FC<MapSearchProps> = t0 => {
  const $ = _c(10);
  const {
    value,
    onChange,
    placeholder: t1,
    onFocus,
    onBlur,
    autoFocus,
    inputRef
  } = t0;
  const placeholder = t1 === undefined ? "Search" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = css({
      width: "full"
    });
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = css.raw({
      width: "full"
    });
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== autoFocus || $[3] !== inputRef || $[4] !== onBlur || $[5] !== onChange || $[6] !== onFocus || $[7] !== placeholder || $[8] !== value) {
    t4 = <div className={t2}><TextInput ref={inputRef} leadingIcon="search" size="md" fullWidth={true} value={value} onChange={onChange} onFocus={onFocus} onBlur={onBlur} placeholder={placeholder} borderRadius="full" className={t3} autoFocus={autoFocus} /></div>;
    $[2] = autoFocus;
    $[3] = inputRef;
    $[4] = onBlur;
    $[5] = onChange;
    $[6] = onFocus;
    $[7] = placeholder;
    $[8] = value;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};